var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.4998V15.5098M10 12.4998C10.4498 12.5011 10.8868 12.3508 11.2407 12.0732C11.5945 11.7956 11.8444 11.4068 11.95 10.9696C12.0557 10.5324 12.0109 10.0724 11.8229 9.66383C11.6349 9.25525 11.3147 8.92196 10.914 8.71777C10.5162 8.51398 10.0611 8.4508 9.62281 8.53849C9.18451 8.62619 8.78879 8.8596 8.5 9.20077M17.875 5.76977C18.575 6.16777 19.005 6.91277 19 7.71777V15.0018C19 15.8108 18.557 16.5568 17.842 16.9498L11.092 21.2198C10.7574 21.4035 10.3818 21.4998 10 21.4998C9.61824 21.4998 9.24264 21.4035 8.908 21.2198L2.158 16.9498C1.80817 16.7586 1.51612 16.4769 1.31241 16.1342C1.1087 15.7916 1.0008 15.4004 1 15.0018V7.71677C1 6.90777 1.443 6.16277 2.158 5.76977L8.908 1.78977C9.25254 1.59981 9.63956 1.50018 10.033 1.50018C10.4264 1.50018 10.8135 1.59981 11.158 1.78977L17.908 5.76977H17.875Z",
    stroke: "#7EA5CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.8ee29a17.svg";
export { ForwardRef as ReactComponent };